(function () {
  function activate(root, tab) {
    if (!root || !tab) return;
    var id = tab.getAttribute('data-rof-fit-tab');
    var tabs = root.querySelectorAll('[data-rof-fit-tab]');
    var panels = root.querySelectorAll('[data-rof-fit-panel]');
    tabs.forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panels.forEach(function (panel) {
      var on = panel.getAttribute('data-rof-fit-panel') === id;
      panel.classList.toggle('is-active', on);
      if (on) panel.removeAttribute('hidden');
      else panel.setAttribute('hidden', '');
    });
  }

  function startTab(root) {
    if (!root) return;
    var start = root.getAttribute('data-rof-fit-start');
    if (!start) return;
    var tab = root.querySelector('[data-rof-fit-tab="' + start + '"]');
    if (tab) activate(root, tab);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rof-fit]').forEach(function (root) {
      if (root.getAttribute('data-rof-fit-booted') === '1') return;
      root.setAttribute('data-rof-fit-booted', '1');
      startTab(root);
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-rof-fit-tab]');
    if (!tab) return;
    var root = tab.closest('[data-rof-fit]');
    if (!root) return;
    event.preventDefault();
    activate(root, tab);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) boot(event.target);
  });
})();
